import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'RequestChangeEmail',
  data: function () {
    return {
      password: '',
      completed: false,
      showMsg: false,
      message: '',
      isInComm: false,
    }
  },
  computed: {
    changeEnabled: function () {
      return !this.isInComm && !this.completed;
    },
  },
  methods: {
    redirectBack() {
      this.$router.go(-1);
    },
    changeEmail() {
      this.isInComm = true;
      axios.post('/account/ChangeEmailRequest', { Value: this.password })
        .then(response => {
          this.isInComm = false;
          if (response.status == 200 && (!response.data || response.data.data.status == 0)) {
            this.message = this.$t('ChangeEmailRequest');
            this.completed = true;
            setTimeout(() => { this.redirectBack(); }, 5000);
          }
          else {
            this.message = response.data.data.text;
            setTimeout(() => { this.showMsg=false; }, 5000);
          }
          this.showMsg = true;
        })
        .catch(e => { this.message = e.message; this.completed = true; this.showMsg = true; })
    },
  },
}
